export default __webpack_public_path__ + "static/media/3.5bb88c01.png";